import { Mixpanel } from "./mixpanel";

export function trackEvent(name: string, props: any = {}) {
  Mixpanel.track(name, props);
}
